
<template>
    <div id="agGeocode">
        <div class="agInputGroup agInputGroupCentered">
            <label>Connection (AGOL):</label>
            <b-form-select 
                class="agLargeInput"
                v-model="geoInput.connection" 
                :options="connections" 
                :disabled="disableUI">
            </b-form-select>
        </div>
        <label id="agGeocode-creditsNote" class="agNote">ArcGIS Online credits may be charged by ESRI</label>
        <b-input-group  class="agInputGroup" prepend="Geocode URL:">
            <b-input
                class="agLargeInput"
                v-model="geoInput.config.geocodeUrl"
                type="text" 
                :disabled="disableUI">
            </b-input>
        </b-input-group >
        <ag-sub-input
            ref="address"
            :initText="geoInput.config.address"
            :type="'textarea'"
            :workflow="workflow"
            :rows="5"
            :maxRows="5"
            :noResize="true"
            :label="'Address:'"
            :disabled="disableUI">
        </ag-sub-input>
        <ag-sub-input
            ref="extent"
            :initText="geoInput.config.extent"
            :type="'textarea'"
            :workflow="workflow"
            :rows="5"
            :maxRows="5"
            :noResize="true"
            :label="'Search Extent:'"
            :placeholder="'e.g. {x:-13049248, y:4016899.5, spatialReference:{wkid:102100}}'"
            :disabled="disableUI">
        </ag-sub-input>
        <div class="agInputGroup agInputGroupCentered">
            <b-input-group class="agInputGroup agInputGroupInline" prepend="Out Spatial Reference (WKID)">
                <b-input 
                    class="agSmallInput"
                    type="number" 
                    v-model="geoInput.config.outSR"
                    autocomplete="false"
                    :disabled="disableUI">
                </b-input>
            </b-input-group>
        </div>
        <label class="agNote">{{`Output will be stored in field ${geoInput.shortname}.GEOMETRY`}}</label>
    </div>
</template>






<script>

// components
import SubInput from "comp/ui/SubInput"

// modules

export default {
    name: "ag-geoInput-geocode",
    components: {
        "ag-sub-input": SubInput
    },
    props:{
        disableUI: Boolean,
        workflow: Object,
        geoInput: Object,
    },
    data(){
        return {
        };
    },
    computed: {

        connections() {
          var connections = [];
          var agolConnections = this.$store.getters["connStore/getAGOLConns"];
          for(var i = 0; i < agolConnections.length; i++)
          {
            var conn = agolConnections[i];
            var connItem = {value: conn, text: conn.name};
            connections.push(connItem);

            if(this.geoInput.connection && conn._id == this.geoInput.connection._id) {
              this.geoInput.connection = conn;
            }
          }
          return connections;
        },

    },
    watch: {
     
    },

    created() {

    },

    mounted() {
        this.reset();
    },

    methods: {



        // emitted Events


        // other

        reset() {
            // init config object if it's empty
            if (Object.keys(this.geoInput.config).length == 0) {
                this.geoInput.config = {
                    connection: null,
                    geocodeUrl: "http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
                    address: null,
                    extent: null,
                    distance: null,
                    fields: []
                };
            }
        },

        prepareForSave() {
            this.geoInput.config.address = this.$refs["address"].text;
            this.geoInput.config.extent = this.$refs["extent"].text;
            this.geoInput.config.fields = ["GEOMETRY"];
        },

         
    }
}

</script>






<style scoped lang="css">

#agGeocode-creditsNote {
    position: relative;
    top: -15px;
    margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/geoInputs/Geocode.vue